module.exports = __webpack_public_path__ + "assets/img/img257.9718fad9.png";